module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Equalizer-ab7c7a37c7f070ba57fe4ee2e567f7f1.svg";